const BACKEND_URL =
  process.env.REACT_APP_BACKEND_URL || "https://backend.safiyaenterprise.com";

export const apiUrl = (path = "") => {
  const normalizedPath = String(path).replace(/^\/+/, "");
  return `${BACKEND_URL}/${normalizedPath}`;
};

export const assetUrl = (path = "") => {
  const normalizedPath = String(path).replace(/^\/+/, "");
  return `${BACKEND_URL}/${normalizedPath}`;
};

export { BACKEND_URL };
